import routes from "../constants/routes";
import { lazyLoadRoutes } from "../utils/lazy-loader";

export const leaveRoutes = [
  {
    path: routes.leave.leaveType,
    element: lazyLoadRoutes("leave/leave-type/index"),
  },
  {
    path: routes.leave.leaveSetting,
    element: lazyLoadRoutes("leave/leave-setting/list"),
  },
  {
    path: routes.leave.addLeaveSetting,
    element: lazyLoadRoutes("leave/leave-setting/add"),
  },
  {
    path: `${routes.leave.addLeaveSetting}/:id`,
    element: lazyLoadRoutes("leave/leave-setting/add"),
  },
  {
    path: routes.leave.holidayType,
    element: lazyLoadRoutes("leave/holiday-type/index"),
  },
  {
    path: routes.leave.holiday,
    element: lazyLoadRoutes("leave/holiday/index"),
  },
  {
    path: routes.leave.manualLeave,
    element: lazyLoadRoutes("leave/manual-leave/index"),
  },
  {
    path: routes.leave.leaveApplication,
    element: lazyLoadRoutes(
      "leave/leave-application/pages/LeaveAplicationList"
    ),
  },
  {
    path: routes.leave.leaveReport,
    element: lazyLoadRoutes("leave/leave-report/pages/leave-report"),
  },
];
